<template>
  <vue-splitter
    :margin="30"
    :horizontal="horizontal"
    style="display: flex; height:  100%; overflow: hidden "
  >
    <GroupTree
      slot="left-pane"
      :clear="clear_list"
      :parent_filter="filter"
      @choice="choice"
      @filter="update_filter"
    />
    <GroupInfo
      slot="right-pane"
      :group="cur_group"
      @clear="clear"
    />
  </vue-splitter>
</template>

<script>
import GroupInfo from './Info/Index.vue'
import GroupTree from './Tree/Index.vue'
import VueSplitter from '@rmp135/vue-splitter'
import DeviceGroupTree from "@/views/Dashboard/General/DeviceGroups/Tree/Index.vue";
import DeviceGroupInfo from "@/views/Dashboard/General/DeviceGroups/Info/Index.vue";
export default {
  name: 'SimCardDevicesGroup',
  components: {
    DeviceGroupInfo,
    DeviceGroupTree,
      GroupInfo,
    VueSplitter,
      GroupTree
  },
  data () {
    return {
      new_group: '',
      cur_group: {},
      clear_list: false,
      filter: {
        searchword: '',
        group_id: null
      }
    }
  },
  computed:{
    horizontal(){
      return document.documentElement.clientWidth <= 768;
    }
  },

  watch:{
    filter: {
      deep: true,
      handler(){
        if (this.$route.name === 'simcard_devices_groups'){
          let string = '?'

          for (let key in this.filter) {
            switch (key) {
              case 'searchword':
                if(this.filter[key] !== "" && this.filter[key] !== null && this.filter[key] !== undefined){
                  string += '&' + key + '=' + this.filter[key]
                }
                break
              case 'group_id':
                if(this.filter[key] && this.filter[key] !== null && this.filter[key] !== undefined){
                  string += '&' + key + '=' + this.filter[key]
                }
                break;
            }
          }

          history.pushState(null, null, this.$route.path + string)
        }
      }
    },
  },

  activated () {
    this.check_query()
  },

  methods: {
    check_query(){
      if (Object.keys(this.$route.query).length > 0){
        for (let key in this.$route.query){
          switch (key) {
            case 'searchword':
              this.filter[key] = this.$route.query[key]
              break;

            case 'group_id':
              this.cur_group = this.$store.getters.getSimcardDevicesGroupById(this.$route.query[key])
              break;
          }
        }
      }
    },
    update_filter(new_filter){
      this.filter = new_filter
    },
    choice (group) {
      this.cur_group = group
    },
    clear(){
      this.clear_list = !this.clear_list
    }
  }
}
</script>
